// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cfb6d92a","453":"9c2177d4"}[chunkId] + ".chunk.js";
};